import { useQuery } from '@tanstack/react-query';
import { sendRequest } from 'api/sendRequest';

import { endpoints } from 'constants/endpoints';
import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

export const saveDisciplinaryActionsSettingsApi = (payload) => {
  const url = endpoints.disciplinaryActions.disciplinaryActionsSettings;
  return sendRequest({
    url,
    credentials: 'include',
    method: 'PATCH',
    body: payload,
  });
};

const getDisciplinaryActionsSettingsApi = () => {
  const url = endpoints.disciplinaryActions.disciplinaryActionsSettings;
  return sendRequest({
    url,
    credentials: 'include',
    method: 'GET',
  });
};

export const useGetDisciplinaryActionsSettings = () =>
  useQuery(
    [REACT_QUERY_KEYS.disciplinaryActions.getDisciplinaryActionsSettings],
    () => getDisciplinaryActionsSettingsApi(),
    {
      enabled: true,
    }
  );

export const useSaveDisciplinaryActionsSettings = ({ payload }) =>
  useQuery(
    [REACT_QUERY_KEYS.disciplinaryActions.saveDisciplinaryActionsSettings],
    () => saveDisciplinaryActionsSettingsApi({ payload }),
    {
      enabled: true,
    }
  );
